import { Outlet } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';

const LoginWrapper = () => {
  const methods = useForm();
  return (
    <FormProvider {...methods}>
      <Outlet />
    </FormProvider>
  );
};

export default LoginWrapper;
